import { Box, Flex } from '@chakra-ui/react';

import { BulkActionBarProps } from './BulkActionBar.types';

function BulkActionBar({ onDeselectAll, selectedCount, cta, ...props }: BulkActionBarProps) {
  return (
    <Flex
      flex="1"
      direction="row"
      justify="space-between"
      align="center"
      w="full"
      p="6px 10px"
      borderRadius="10px"
      bg="brand.mutedPurple"
      color="brand.white"
      {...props}
    >
      <Flex direction="row" align="center" gap="20px">
        <Box
          p="10px 15px"
          bg="brand.darkGray"
          borderRadius="5px"
          color="brand.white"
          minW="28px"
          textAlign="center"
          sx={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {selectedCount}
        </Box>
        <Box>selected</Box>
        <Box
          as="button"
          borderBottom="1px solid"
          borderColor="brand.white"
          onClick={onDeselectAll}
          _hover={{ borderColor: 'brand.purple', color: 'brand.purple' }}
          cursor="pointer"
          sx={{
            background: 'none',
            color: 'inherit',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            padding: 0,
          }}
        >
          Deselect all
        </Box>
      </Flex>

      {cta}
    </Flex>
  );
}

export default BulkActionBar;
